export default {
	setMenuBreadcrumbItems(state, items) {
		state.menu.breadcrumbItems = items;
	}
};
